export default "__VITE_ASSET__CQMoGnQV__"